export const API_FETCH_INTERVAL = 8000;
export const API_FETCH_THROTTLE = 500;
